var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33334 5.33333C1.33334 3.49238 2.82573 2 4.66668 2H11.3333C13.1743 2 14.6667 3.49238 14.6667 5.33333V11.3333C14.6667 13.1743 13.1743 14.6667 11.3333 14.6667H4.66668C2.82573 14.6667 1.33334 13.1743 1.33334 11.3333V5.33333ZM4.66668 3.33333C3.56211 3.33333 2.66668 4.22876 2.66668 5.33333V11.3333C2.66668 12.4379 3.56211 13.3333 4.66668 13.3333H11.3333C12.4379 13.3333 13.3333 12.4379 13.3333 11.3333V5.33333C13.3333 4.22876 12.4379 3.33333 11.3333 3.33333H4.66668Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33332 1.33331C5.70151 1.33331 5.99999 1.63179 5.99999 1.99998V3.99998C5.99999 4.36817 5.70151 4.66665 5.33332 4.66665C4.96513 4.66665 4.66666 4.36817 4.66666 3.99998V1.99998C4.66666 1.63179 4.96513 1.33331 5.33332 1.33331Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.66667C4 6.29848 4.29848 6 4.66667 6H11.3333C11.7015 6 12 6.29848 12 6.66667C12 7.03486 11.7015 7.33333 11.3333 7.33333H4.66667C4.29848 7.33333 4 7.03486 4 6.66667Z",
    fill: "#6B7280"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.3334C10 10.9652 10.2985 10.6667 10.6667 10.6667L11.3333 10.6667C11.7015 10.6667 12 10.9652 12 11.3334C12 11.7015 11.7015 12 11.3333 12H10.6667C10.2985 12 10 11.7015 10 11.3334Z",
    fill: "#6B7280"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 1.33331C11.0349 1.33331 11.3333 1.63179 11.3333 1.99998V3.99998C11.3333 4.36817 11.0349 4.66665 10.6667 4.66665C10.2985 4.66665 10 4.36817 10 3.99998V1.99998C10 1.63179 10.2985 1.33331 10.6667 1.33331Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectCalendar);
export default __webpack_public_path__ + "static/media/select-calendar.556e6ffbdc0da88b9de08a35c640b31e.svg";
export { ForwardRef as ReactComponent };